<template>
  <div class="main-view">
    <Navigation v-show="navigation" />
    <router-view />
    <Footer v-show="navigation" />
  </div>
</template>

<script>
import Navigation from "./components/NavComponent.vue";
import Footer from "./components/FooterComponent.vue";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "app",
  components: { Navigation, Footer },
  data() {
    return {
      navigation: null,
    };
  },
  created() {
    this.checkRoute();
    this.$store.dispatch("getPosts");
  },
  mounted() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.$store.commit("setIsLoggedIn", true);
        if (this.$store.state.userProfile === null) {
          this.$store.dispatch("fetchUserProfile");
        }
      } else {
        this.$store.commit("setIsLoggedIn", false);
      }
    });
  },
  methods: {
    checkRoute() {
      if (
        this.$route.name === "Login" ||
        this.$route.name === "Register" ||
        this.$route.name === "ResetPassword"
      ) {
        this.navigation = false;
        return;
      }
      this.navigation = true;
    },
  },
  watch: {
    $route() {
      this.checkRoute();
    },
  },
};
</script>

<style >
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Quicksand", sans-serif;
}
.ql-editor {
  font-size: 16px;
}
.main-view {
  display: flex;
  flex-flow: column;
  min-height: 100vh;
}
</style>
